/**
 * LD Product Variants - Variant selector initialization and management
 */

class LDProductVariants {
  constructor() {
    this.init();
  }

  /**
   * Initialize variant selector
   */
  initVariantSelector() {
    console.log('LD Product Variants: Initializing variant selector...');
    
    // Check if we have radio button variant selectors
    const variantInputs = document.querySelectorAll('.ld-product-page__option-input');
    if (variantInputs.length === 0) {
      console.log('LD Product Variants: No variant selector found');
      return;
    }
    
    console.log('LD Product Variants: Found', variantInputs.length, 'variant options');
    
    // Mark form as handled to prevent conflicts
    const form = document.querySelector('#product-form-ld-product-page');
    if (form) {
      form.dataset.ldHandled = 'true';
      console.log('LD Product Variants: Form marked as handled');
    }
    
    console.log('LD Product Variants: Variant selector initialized');
  }

  init() {
    this.initVariantSelector();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.ldProductVariants = new LDProductVariants();
});

// Export for ES modules
window.LDProductVariants = LDProductVariants;
